/**
 * Fotografía de la marca.
 *
 * Vienen del sitio de Soham Home (`Web/sohamiot-web/`), convertidas a WebP de 1280 px
 * para que la aplicación siga abriendo sin señal: 578 KB las seis, contra 4.7 MB los
 * PNG originales.
 *
 * REGLA DURA, del manual de marca §7: **una foto ilustra un solo concepto**. No se
 * reutiliza una imagen genérica para representar algo distinto. Por eso este mapa está
 * incompleto a propósito: solo aparecen las categorías donde la fotografía dice la
 * verdad. Las demás se dibujan con su nombre, que es honesto y no finge.
 *
 * SEGUNDA REGLA, y esta es de producto: **estas imágenes son ilustrativas de la marca,
 * no fotografías de obra propia.** `PRODUCT.md` declara que todavía no hay fotos de
 * trabajo real en el sistema. Nunca se rotulan como «nuestro trabajo» ni como caso.
 * El día que existan fotos de obra, se sustituyen aquí y en ningún otro lado.
 */

export const FOTO_CATEGORIA = {
  cto:  '/fotos/contactos.webp',  // Contactos — IA (Antigravity, 2026-08-22), ilustrativa
  tab:  '/fotos/tablero.webp',    // Tablero y carga — IA, ilustrativa
  med:  '/fotos/medicion.webp',   // Medición — la pinza amperimétrica; IA, ilustrativa
  ilu:  '/fotos/lighting.webp',   // Iluminación — el propio tema de la foto
  seg:  '/fotos/security.webp',   // Seguridad
  arq:  '/fotos/celosias.webp',   // Arquitectónico — celosía cortada
  aut:  '/fotos/hero.webp',       // Automatización — tablero de casa
  fach: '/fotos/puertas.webp',    // Fachada y exterior (taller)
  int:  '/fotos/woodwall.webp',   // Interiores — lambrín de madera (taller)
  mue:  '/fotos/woodwall.webp'    // Muebles — misma familia de material
}

/**
 * Las imágenes de los RUBROS de la pared del inicio (F3 / tanda IA de Antigravity,
 * 2026-08-22): ilustrativas, no obra propia. `electrico.webp` se rechazó (franjas negras) y
 * se regenera; mientras, Eléctrico sigue con el gráfico del tablero.
 */
export const FOTO_RUBRO = {
  riego:   '/fotos/riego.webp',
  wifi:    '/fotos/wifi.webp',
  camaras: '/fotos/camaras.webp'
}

/** Foto de portada de la propuesta y del primer arranque. */
export const FOTO_PORTADA = '/fotos/hero.webp'

export const fotoDe = cat => FOTO_CATEGORIA[cat] || null
